import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import '../../../assets/css/admin/adminBlogs/admblogcard.css';

const AdmBlogCard = () => {
  const { baseUrl, authToken, blogs, setBlogs, openEditBlog } = useContext(AppContext);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    setloading(true);
    axios.get(`${baseUrl}/admin/view-blog`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then((res) => {
        if (res.data.success) {
          setBlogs(res.data.data);
        }
      })
      .catch((err) => console.error('Fetch blogs error:', err));
    setloading(false);
  }, []);

  const handleDelete = (blogId) => {
    if (!window.confirm('Are you sure you want to delete this blog?')) return;

    axios.delete(`${baseUrl}/admin/delete-blog/${blogId}`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then((res) => {
        if (res.data.success) {
          setBlogs(prev => prev.filter(b => b.id !== blogId));
        } else {
          alert(res.data.message || 'Delete failed');
        }
      })
      .catch((err) => {
        console.error('Delete blog error:', err);
        alert('Unable to connect to server');
      });
  };
  const formatDate = (date) =>
    new Date(date).toLocaleDateString('en-US', {
      year: 'numeric', month: 'short', day: 'numeric'
    });

  const getCategoryIcon = (category) => {
    const icons = {
      'Event Blogs': '🎪',
      'Food Blogs': '🍽️'
    };
    return icons[category] || '📄';
  };

  if (blogs.length === 0) {
    return (
      <div className="adm-blog-empty">
        <div className="adm-blog-empty-icon">📭</div>
        <h3>No blogs found</h3>
        <p>Create your first blog</p>
      </div>
    );
  }

  return (
    <div className="adm-blog-cards-grid">
      {blogs.map(blog => (
        <div key={blog.id} className={`adm-blog-card adm-blog-${blog.post_status}`}>

          {/* Image */}
          <div className="adm-blog-card-image">
            <img
              src={
                blog.published_image
                  ? `http://127.0.0.1:8000/storage/${blog.published_image}`
                  : '/placeholder.jpg'
              }
              alt={blog.post_title}
              onError={(e) => {
                e.target.src = '/placeholder.jpg';
              }}
            />
            <div className="adm-blog-image-overlay">
              <span className={`adm-blog-status-badge adm-blog-${blog.post_status}`}>
                {blog.post_status === 'published' ? 'Published' : 'Draft'}
              </span>
            </div>
          </div>

          {/* Content */}
          <div className="adm-blog-card-content">

            <div className="adm-blog-category">
              <span className="adm-blog-category-tag">
                {getCategoryIcon(blog.post_category)} {blog.post_category}
              </span>
            </div>

            <h3 className="adm-blog-title">{blog.post_title}</h3>
            <p className="adm-blog-description">{blog.post_content?.substring(0, 100)}...</p>

            <div className="adm-blog-meta">
              <div className="adm-blog-meta-item">
                <span className="adm-blog-meta-icon">📅</span>
                <span>{formatDate(blog.created_at)}</span>
              </div>
            </div>

            {/* Action buttons */}
            <div className="adm-blog-card-actions">

              <button
                className="adm-blog-btn-card-action adm-blog-btn-edit"
                onClick={() => openEditBlog(blog)}
              >
                ✏️ Edit
              </button>

              <button
                className="adm-blog-btn-card-action adm-blog-btn-delete"
                onClick={() => handleDelete(blog.id)}
              >
                🗑️ Delete
              </button>

            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdmBlogCard;